import { render, staticRenderFns } from "./additional-supplier-requirements-view-table.vue?vue&type=template&id=c16fd48e&"
import script from "./additional-supplier-requirements-view-table.vue?vue&type=script&lang=js&"
export * from "./additional-supplier-requirements-view-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16fd48e')) {
      api.createRecord('c16fd48e', component.options)
    } else {
      api.reload('c16fd48e', component.options)
    }
    module.hot.accept("./additional-supplier-requirements-view-table.vue?vue&type=template&id=c16fd48e&", function () {
      api.rerender('c16fd48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/additional-supplier-requirements-view-table.vue"
export default component.exports